import { Dashboard } from "./pages/dashboard"
import ErrorStatusView from "./pages/error-status-view"
import { ForgotPassword } from "./pages/forgot-password"
import { Login } from "./pages/login/Login"
import { OLWrapper } from "./components/AppWrappers/OLWrapper"
import { QBWrapper } from "./components/AppWrappers/QBWrapper"
import { DBWrapper } from "./components/AppWrappers/DBWrapper"
import { DEFWrapper } from "./components/AppWrappers/DEFWrapper"
import { DLWrapper } from "./components/AppWrappers/DLWrapper"
import { DCWrapper } from "./components/AppWrappers/DCWrapper"
import { LBWrapper } from "./components/AppWrappers/LBWrapper"
import { RBWrapper } from "./components/AppWrappers/RBWrapper"
import { SWrapper } from "./components/AppWrappers/SWrapper"
import { STWrapper } from "./components/AppWrappers/STWrapper"
import { TEWrapper } from "./components/AppWrappers/TEWrapper"
import { WRWrapper } from "./components/AppWrappers/WRWrapper"

export const routes = [
	{
		path: "/",
		element: <Dashboard />,
		protected: true,
	},
	{
		path: "/ol/*",
		element: <OLWrapper />,
		protected: true,
	},
	{
		path: "/qb/*",
		element: <QBWrapper />,
		protected: true,
	},
	{
		path: "/db/*",
		element: <DBWrapper />,
		protected: true,
	},
	{
		path: "/def/*",
		element: <DEFWrapper />,
		protected: true,
	},
	{
		path: "/dl/*",
		element: <DLWrapper />,
		protected: true,
	},
	{
		path: "/dc/*",
		element: <DCWrapper />,
		protected: true,
	},
	{
		path: "/lb/*",
		element: <LBWrapper />,
		protected: true,
	},
	{
		path: "/rb/*",
		element: <RBWrapper />,
		protected: true,
	},
	{
		path: "/s/*",
		element: <SWrapper />,
		protected: true,
	},
	{
		path: "/st/*",
		element: <STWrapper />,
		protected: true,
	},
	{
		path: "/te/*",
		element: <TEWrapper />,
		protected: true,
	},
	{
		path: "/wr/*",
		element: <WRWrapper />,
		protected: true,
	},
	{
		path: "/login",
		element: <Login />,
		protected: false,
	},
	{
		path: "/reset-password",
		element: <ForgotPassword />,
		protected: false,
	},
	{
		path: "/forgot-password",
		element: <ForgotPassword />,
		protected: false,
	},
	{
		path: "/status/:code",
		element: <ErrorStatusView />,
		protected: false,
	},
]
